// @ts-nocheck
import { fabric } from 'fabric';
import _ from 'lodash';
import { ANNOTATION_TYPE, DEFAULT_FONT } from '../../../config';
import { mVToPx, pxToMv } from '../../../ui/helper';

// *: lt1 is below text (which contains beat count, average hr)
let HorizontalCaliper;

(function () {
  const STROKE = {
    strokeWidth: 2,
    selectable: false,
    hasControls: false,
    hasBorders: false,
    hasRotatingPoint: false,
    selection: false,
    skipTargetFind: false,
    editable: false,
    stroke: 'red',
    originX: 'center',
    originY: 'center',
    hoverCursor: 'arrow',
  };

  HorizontalCaliper = function (
    cv: any,
    points: any,
    offsetX: any,
    config: any,
    verticalChannelPlacement: any,
    channelIndex: any,
  ) {
    this.type = ANNOTATION_TYPE.HLINE;
    this.canvas = cv;
    this.channelIndex = channelIndex;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.config = config;
    this.isVisible = true;
    this.x1 = points.x1;
    this.x2 = points.x2;
    this.y = points.y;
    this.isSelectedAt = null;
    this.spp = (config.samplingRate * config.wndDuration) / config.width;
    this.convertConstant = (config.wndDuration * 1000) / config.width;
    this.xr = offsetX + this.x1 * this.spp;
    this.yr = pxToMv(verticalChannelPlacement, config, this.y, this.channelIndex);
    this.length = (this.x2 - this.x1) * this.convertConstant;
    this.belowText = '';
    this.colorHLine = 'blue';
  };

  HorizontalCaliper.prototype.updateConfig = function (
    config: any,
    offsetX: any,
    verticalChannelPlacement: any,
    displayedChannelsArr: any,
  ) {
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;

    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      if (this.channelIndex === displayedChannelsArr[i]) {
        this.spp = (config.samplingRate * config.wndDuration) / config.width;
        this.convertConstant = (config.wndDuration * 1000) / config.width;

        this.x1 = (this.xr - offsetX) / this.spp;
        this.x2 = this.length / this.convertConstant + this.x1;

        this.y = mVToPx(verticalChannelPlacement, config, this.yr, i);

        this.ls.set({
          x1: this.x1,
          x2: this.x1,
          y1: this.y - 10,
          y2: this.y + 10,
        });
        this.ls.setCoords();
        this.le.set({
          x1: this.x2,
          x2: this.x2,
          y1: this.y - 10,
          y2: this.y + 10,
        });
        this.le.setCoords();
        this.l.set({
          x1: this.x1,
          x2: this.x2,
          y1: this.y,
          y2: this.y,
        });
        this.l.setCoords();
        this.lt.set({
          fontSize: 14,
          text: `${(Math.abs(this.x1 - this.x2) * this.convertConstant).toFixed(0)} ms`,
          top: this.y - 20,
        });
        this.lt.set({ left: (this.x1 + this.x2) / 2 - this.lt.width / 2 });
        this.lt.setCoords();
        this.lt1.set({
          fontSize: 14,
          text: this.belowText,
          top: this.y + 5,
        });
        this.lt1.set({ left: (this.x1 + this.x2) / 2 - this.lt1.width / 2 });
        this.lt1.setCoords();
        this.isVisibility(true);

        // if (this.y + 10 >= 0 && this.y - 10 <= this.config.height) {
        //   this.isVisibility(true);
        // } else {
        //   this.isVisibility(false);
        // }

        break;
      } else {
        this.isVisibility(false);
      }
    }
  };

  HorizontalCaliper.prototype.updateChannelIdx = function (channelIndex: any) {
    this.channelIndex = channelIndex;
  };

  HorizontalCaliper.prototype.draw = function () {
    this.ls = new fabric.Line([this.x1, this.y - 10, this.x1, this.y + 10], STROKE);
    this.ls.id = 'ls';
    this.l = new fabric.Line([this.x1, this.y, this.x2, this.y], STROKE);
    this.l.id = 'l';
    this.le = new fabric.Line([this.x2, this.y - 10, this.x2, this.y + 10], STROKE);
    this.le.id = 'le';
    this.lt = new fabric.Text('0 ms', {
      left: this.x1,
      selectable: false,
      top: this.y - 20,
      fontFamily: DEFAULT_FONT,
      fontSize: 14,
      fill: this.colorHLine,
      hoverCursor: 'arrow',
    });
    this.lt.id = 'lt';
    this.lt1 = new fabric.Text(this.belowText, {
      fontFamily: DEFAULT_FONT,
      left: this.x1,
      selectable: false,
      top: this.y + 5,
      fontSize: 14,
      fill: this.colorHLine,
      hoverCursor: 'arrow',
    });
    this.lt1.id = 'lt1';
    this.canvas.add(this.ls, this.l, this.le, this.lt, this.lt1);
  };

  HorizontalCaliper.prototype.drawImport = function () {
    const STROKEIMPORT = {
      strokeWidth: 2,
      selectable: false,
      hasControls: false,
      hasBorders: false,
      hasRotatingPoint: false,
      selection: false,
      skipTargetFind: false,
      editable: false,
      stroke: this.colorHLine,
      originX: 'center',
      originY: 'center',
      hoverCursor: 'arrow',
    };

    this.ls = new fabric.Line([this.x1, this.y - 10, this.x1, this.y + 10], STROKEIMPORT);
    this.ls.id = 'ls';
    this.l = new fabric.Line([this.x1, this.y, this.x2, this.y], STROKEIMPORT);
    this.l.id = 'l';
    this.le = new fabric.Line([this.x2, this.y - 10, this.x2, this.y + 10], STROKEIMPORT);
    this.le.id = 'le';
    this.lt = new fabric.Text('0 ms', {
      left: this.x1,
      selectable: false,
      top: this.y - 20,
      fontFamily: DEFAULT_FONT,
      fontSize: 14,
      fill: this.colorHLine,
      hoverCursor: 'arrow',
    });
    this.lt.id = 'lt';
    this.lt1 = new fabric.Text(this.belowText, {
      fontFamily: DEFAULT_FONT,
      left: this.x1,
      selectable: false,
      top: this.y + 5,
      fontSize: 14,
      fill: this.colorHLine,
      hoverCursor: 'arrow',
    });
    this.lt1.id = 'lt1';
    this.canvas.add(this.ls, this.l, this.le, this.lt, this.lt1);
  };

  HorizontalCaliper.prototype.render = function () {
    if (
      !(
        (this.x1 < 0 && this.x2 < 0) ||
        (this.x1 > this.config.width && this.x2 > this.config.width)
      )
    ) {
      this.canvas.renderAll();
    }
  };

  HorizontalCaliper.prototype.update = function (
    delta: any,
    isDrawing: any,
    displayedChannelsArr: any,
    isScrolling: any,
    leValue: any,
    beatMarkers: any,
    offsetX: any,
  ) {
    this.belowText = this.calculateBelowText(beatMarkers, offsetX);

    if (this.isSelectedAt === 'le' || isDrawing || isScrolling) {
      this.x2 = !isScrolling ? this.x2 + delta.dx : leValue;
      this.length = (this.x2 - this.x1) * this.convertConstant;

      this.l.set({ x2: this.x2 });
      this.l.setCoords();
      this.le.set({ x1: this.x2, x2: this.x2 });
      this.le.setCoords();

      this.lt.set({
        text: `${(Math.abs(this.x1 - this.x2) * this.convertConstant).toFixed(0)} ms`,
      });
      this.lt.set({ left: (this.x1 + this.x2) / 2 - this.lt.width / 2 });
      this.lt.setCoords();

      this.lt1.set({
        text: this.belowText,
      });
      this.lt1.set({ left: (this.x1 + this.x2) / 2 - this.lt1.width / 2 });
      this.lt1.setCoords();
    } else if (this.isSelectedAt === 'ls') {
      this.x1 += delta.dx;
      this.xr += delta.dx * this.spp;
      this.length = (this.x2 - this.x1) * this.convertConstant;

      this.l.set({ x1: this.x1 });
      this.l.setCoords();
      this.ls.set({ x1: this.x1, x2: this.x1 });
      this.ls.setCoords();

      this.lt.set({
        text: `${(Math.abs(this.x1 - this.x2) * this.convertConstant).toFixed(0)} ms`,
      });
      this.lt.set({ left: (this.x1 + this.x2) / 2 - this.lt.width / 2 });
      this.lt.setCoords();

      this.lt1.set({ text: this.belowText });
      this.lt1.set({ left: (this.x1 + this.x2) / 2 - this.lt1.width / 2 });
      this.lt1.setCoords();
    } else if (this.isSelectedAt === 'l') {
      this.x1 += delta.dx;
      this.x2 += delta.dx;
      this.y += delta.dy;
      this.xr += delta.dx * this.spp;
      for (let i = 0; i < displayedChannelsArr.length; i += 1) {
        if (this.channelIndex === displayedChannelsArr[i]) {
          this.yr = pxToMv(this.verticalChannelPlacement, this.config, this.y, i);
        }
      }

      this.l.set({
        x1: this.x1,
        y1: this.y,
        x2: this.x2,
        y2: this.y,
      });
      this.l.setCoords();

      this.lt.set({
        left: (this.x1 + this.x2) / 2 - this.lt.width / 2,
        top: this.y - 20,
      });
      this.lt.setCoords();

      this.lt1.set({
        top: this.y + 5,
        text: this.belowText,
      });
      this.lt1.set({ left: (this.x1 + this.x2) / 2 - this.lt1.width / 2 });
      this.lt1.setCoords();

      this.ls.set({
        x1: this.x1,
        y1: this.y - 10,
        x2: this.x1,
        y2: this.y + 10,
      });
      this.ls.setCoords();

      this.le.set({
        x1: this.x2,
        y1: this.y - 10,
        x2: this.x2,
        y2: this.y + 10,
      });
      this.le.setCoords();
    }

    // editing out-range
    // if (this.y + 10 >= 0 && this.y - 10 <= this.config.height) {
    //   this.isVisibility(true);
    // } else {
    //   this.isVisibility(false);
    // }
  };

  HorizontalCaliper.prototype.updateBelowText = function (beatMarkers: any, offsetX: any) {
    this.belowText = this.calculateBelowText(beatMarkers, offsetX);
    this.lt1.set({ text: this.belowText });
    this.lt1.set({ left: (this.x1 + this.x2) / 2 - this.lt1.width / 2 });
    this.lt1.setCoords();
    this.render();
  };

  HorizontalCaliper.prototype.changeColor = function (color: any) {
    this.colorHLine = color;

    // *: Change color after choose menu option
    this.ls.set({ stroke: this.colorHLine });
    this.l.set({ stroke: this.colorHLine });
    this.le.set({ stroke: this.colorHLine });
    this.lt.set({ fill: this.colorHLine });
    this.lt1.set({ fill: this.colorHLine });
  };

  HorizontalCaliper.prototype.scroll = function (offsetX: any, displayedChannelsArr: any) {
    for (let i = 0; i < displayedChannelsArr.length; i += 1) {
      if (this.channelIndex === displayedChannelsArr[i]) {
        const d = this.x2 - this.x1;
        this.x1 = (this.xr - offsetX) / this.spp;
        this.x2 = this.x1 + d;

        this.l.set({ x1: this.x1, x2: this.x2 });
        this.l.setCoords();
        this.ls.set({ x1: this.x1, x2: this.x1 });
        this.ls.setCoords();
        this.le.set({ x1: this.x2, x2: this.x2 });
        this.le.setCoords();
        this.lt.set({ left: (this.x1 + this.x2) / 2 - this.lt.width / 2 });
        this.lt.setCoords();
        this.lt1.set({ left: (this.x1 + this.x2) / 2 - this.lt1.width / 2 });
        this.lt1.setCoords();

        if (
          (this.x1 < 0 && this.x2 < 0) ||
          (this.x1 > this.config.width && this.x2 > this.config.width)
        ) {
          this.isVisibility(false);
        } else {
          this.isVisibility(true);
        }
        break;
      }
    }
  };

  HorizontalCaliper.prototype.isSelected = function (pointer: any) {
    if (this.x1 <= this.x2) {
      if (
        pointer.x > this.x1 + 5 &&
        pointer.x < this.x2 - 5 &&
        pointer.y > this.y - 5 &&
        pointer.y < this.y + 5
      ) {
        this.isSelectedAt = 'l';
      } else if (
        pointer.x > this.x1 - 5 &&
        pointer.x < this.x1 + 5 &&
        pointer.y > this.y - 10 &&
        pointer.y < this.y + 10
      ) {
        this.isSelectedAt = 'ls';
      } else if (
        pointer.x > this.x2 - 5 &&
        pointer.x < this.x2 + 5 &&
        pointer.y > this.y - 10 &&
        pointer.y < this.y + 10
      ) {
        this.isSelectedAt = 'le';
      } else {
        this.isSelectedAt = null;
      }
    } else if (this.x1 > this.x2) {
      if (
        pointer.x > this.x2 + 5 &&
        pointer.x < this.x1 - 5 &&
        pointer.y > this.y - 5 &&
        pointer.y < this.y + 5
      ) {
        this.isSelectedAt = 'l';
      } else if (
        pointer.x > this.x2 - 5 &&
        pointer.x < this.x2 + 5 &&
        pointer.y > this.y - 10 &&
        pointer.y < this.y + 10
      ) {
        this.isSelectedAt = 'le';
      } else if (
        pointer.x > this.x1 - 5 &&
        pointer.x < this.x1 + 5 &&
        pointer.y > this.y - 10 &&
        pointer.y < this.y + 10
      ) {
        this.isSelectedAt = 'ls';
      } else {
        this.isSelectedAt = null;
      }
    }

    if (this.isSelectedAt) {
      return true;
    }
    return false;
  };

  HorizontalCaliper.prototype.select = function () {
    this.ls.set({ stroke: 'red' });
    this.l.set({ stroke: 'red' });
    this.le.set({ stroke: 'red' });
    this.lt.set({ fill: 'red' });
    this.lt1.set({ fill: 'red' });
  };

  HorizontalCaliper.prototype.deselect = function () {
    this.ls.set({ stroke: this.colorHLine });
    this.l.set({ stroke: this.colorHLine });
    this.le.set({ stroke: this.colorHLine });
    this.lt.set({ fill: this.colorHLine });
    this.lt1.set({ fill: this.colorHLine });
  };

  HorizontalCaliper.prototype.isVisibility = function (isVisibility: any) {
    this.isVisible = isVisibility;
    this.ls.visible = isVisibility;
    this.l.visible = isVisibility;
    this.le.visible = isVisibility;
    this.lt.visible = isVisibility;
    this.lt1.visible = isVisibility;
  };

  HorizontalCaliper.prototype.getJSONObject = function () {
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      xr: this.xr,
      yr: this.yr,
      length: this.length,
      colorHLine: this.colorHLine,
      belowText: this.belowText,
    };
  };

  HorizontalCaliper.prototype.getBeatMarkerBpm = function (sampleA: any, sampleB: any) {
    const { samplingRate } = this.config;
    const difference = Math.abs(sampleA - sampleB);
    const millisec = (difference * 1000) / samplingRate;
    const bpm = 60 / (millisec / 1000);
    return bpm;
  };

  HorizontalCaliper.prototype.calculateBelowText = function (beatMarkers: any, offsetX: any) {
    const px1 = Math.round(this.x1 / this.config.indexToPix) + offsetX;
    const px2 = Math.round(this.x2 / this.config.indexToPix) + offsetX;
    const sampleA = Math.abs(Math.min(px1, px2));
    const sampleB = Math.abs(Math.max(px1, px2));
    /**
     * Selects the beat markers whose sample positions fall within the caliper span from sampleA to sampleB. Filters beatMarkers inclusively between the two samples.
     *
     * @returns Beat markers inside the caliper period.
     */
    const periodBeatMarkers = _.filter(beatMarkers, (x) => x >= sampleA && x <= sampleB);
    const countBeatMarker = periodBeatMarkers.length
      ? periodBeatMarkers.length > 1
        ? `${periodBeatMarkers.length} beats`
        : `${periodBeatMarkers.length} beat`
      : '';
    if (periodBeatMarkers.length > 1) {
      let sum = 0;
      for (let i = 0; i < periodBeatMarkers.length - 1; i += 1) {
        sum += this.getBeatMarkerBpm(periodBeatMarkers[i], periodBeatMarkers[i + 1]);
      }
      return `${countBeatMarker} - ${Math.round(sum / (periodBeatMarkers.length - 1))} bpm avg`;
    }
    return countBeatMarker;
  };

  HorizontalCaliper.prototype.import = function (data: any) {
    this.channelIndex = data.channelIndex;
    this.xr = data.xr;
    this.yr = data.yr;
    this.length = data.length;
    this.belowText = data.belowText;
    this.colorHLine = data.colorHLine;

    this.x1 = this.xr / this.spp;
    this.x2 = this.length / this.convertConstant + this.x1;
    this.y = mVToPx(this.verticalChannelPlacement, this.config, this.yr, this.channelIndex);

    this.drawImport();

    this.lt.set({
      text: `${(Math.abs(this.x1 - this.x2) * this.convertConstant).toFixed(0)} ms`,
    });
    this.lt.set({
      left: (this.x1 + this.x2) / 2 - this.lt.width / 2,
    });
    this.lt.setCoords();

    this.lt1.set({
      text: data.belowText,
    });
    this.lt1.set({
      left: (this.x1 + this.x2) / 2 - this.lt1.width / 2,
    });
    this.lt1.setCoords();
  };
})();

export { HorizontalCaliper };
export default { HorizontalCaliper };
